import { Provider } from '@cabal/shared/domain/llm/model/enums.js';

export const MINT = '#5FF3B8';
export const PAGE_BACKGROUND = '#000000';
export const GLASS_SHADOW =
  'inset -2px -3px 5px -2px rgba(255,255,255,0.14), inset 1px 1px 1px 0 rgba(255,255,255,0.25)';

export const CARD_RADIUS = 90;
export const AVATAR_WIDTH = 78;
export const AVATAR_ICON_SIZE = 38;
export const AVATAR_PAD_Y = (AVATAR_WIDTH - AVATAR_ICON_SIZE) / 2;
export const CIRCLE_SIZE = AVATAR_WIDTH;
export const ROW_GAP = 20;
export const TITLE_INDENT = AVATAR_WIDTH + ROW_GAP;
export const CARD_PAD_X = 44;
export const CARD_PAD_Y = 30;
export const SOLO_UNITED_GAP = 14;
export const MESSAGE_GAP = 48;
export const MESSAGE_LINE_HEIGHT = 1.68;
export const MESSAGE_TEXT_GRADIENT =
  'linear-gradient(180deg, #FFFFFF 0%, rgba(238,246,242,0.82) 58%, rgba(224,238,232,0.68) 100%)';
export const SCROLL_FADE_PX = 52;

export const CATEGORY_PANEL_WIDTH = '29%';
export const CATEGORY_SPACING = 150;
export const CATEGORY_PILL_HEIGHT = 134;
export const CATEGORY_PILL_LEFT = -44;
export const CATEGORY_PILL_RIGHT = 28;
// Middle item (Proactiveness) — the reel lands here on enter.
export const DEFAULT_ACTIVE_TAB = 3;

export const RAIL_TRANSITION = {
  type: 'spring',
  stiffness: 260,
  damping: 32,
} as const;

export const SECTION_LABEL_SOLO = 'SOLO';
export const SECTION_LABEL_AI = 'AI';
export const SECTION_LABEL_AIS = 'AIS';
export const SECTION_LABEL_UNITED = 'UNITED';

export const MENTION_PROVIDER: Record<string, string> = {
  GPT: Provider.OpenAI,
  Claude: Provider.Anthropic,
  Gemini: Provider.Google,
  Perplexity: Provider.Perplexity,
  Grok: 'x-ai',
  DeepSeek: 'deepseek',
  Mistral: 'mistralai',
  Llama: 'meta-llama',
};
